import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useCanCancelScanRun from "shared/Scan/access/useCanCancelScanRun";
import { ScanRunState } from "types/generated";

import { SCAN_RUN_CANCEL } from "./gql";

export type ScanRunForCancel = {
  id: string;
  state: ScanRunState;
  scan: { space: { id: string } };
};

type UseCancelScanRunOptions = {
  scanRun: ScanRunForCancel;
  refetchQueries?: useMutation.Options["refetchQueries"];
};

const useCancelScanRun = ({ scanRun, refetchQueries }: UseCancelScanRunOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const canCancel = useCanCancelScanRun()(scanRun);

  const [cancelScanRun, { loading: isCanceling }] = useMutation(SCAN_RUN_CANCEL, {
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const cancel = (note?: string | null) =>
    cancelScanRun({ variables: { id: scanRun.id, note: note || null } })
      .then(({ data }) => {
        if (data?.scanRunCancel.id) {
          reportSuccess({ message: "Scan run successfully canceled" });
        }
      })
      .catch(onError);

  return {
    canCancel,
    showCancel: canCancel.result || !!canCancel.message,
    isCanceling,
    cancel,
  };
};

export default useCancelScanRun;
